import React from "react";

import { Container } from "reactstrap";
import ContactForm from "./ContactForm";

import './style.scss'; 
// import TopArc from "../../common/TopArc/TopArc";

export default function Contacts () {
    return (
        <Container fluid className="contacts-page">
            {/* <TopArc/> */}
            <ContactForm/>
        </Container>
    )
}
